module.exports = __webpack_public_path__ + "be73238bb061e442ac61980557597435.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-police.png
// module id = 2739
// module chunks = 0